import { useCallback, useMemo } from "react";
import { monthDays, todayDayOf, makeBudgetCalc, cumulativeByDay } from "./dailyBudgetCalc";

// Günlük bütçe türetilmiş verileri: kalem ağacı, gün haritası, plan toplamları, kümülatifler
export function useDailyBudgetModel(items, daily, month) {
  const byId = useMemo(() => Object.fromEntries(items.map((i) => [i.id, i])), [items]);
  const parents = useMemo(() => items.filter((i) => !i.parent_id), [items]);
  const childrenOf = useMemo(() => {
    const m = {};
    items.forEach((i) => { if (i.parent_id) (m[i.parent_id] = m[i.parent_id] || []).push(i); });
    return m;
  }, [items]);
  const leafs = useMemo(() => items.filter((i) => !childrenOf[i.id]), [items, childrenOf]);
  const dayMap = useMemo(() => Object.fromEntries((Array.isArray(daily.days) ? daily.days : []).map((d) => [d.day, d.items || {}])), [daily]);
  const plans = useMemo(() => daily.plans || {}, [daily]);
  const { y, m, dayCount, dayList } = useMemo(() => monthDays(month), [month]);
  const planOf = useCallback((id) => plans[id] || 0, [plans]);
  const totalPlan = useMemo(() => leafs.reduce((s, l) => s + planOf(l.id), 0), [leafs, planOf]);
  const plannedIds = useMemo(() => new Set(leafs.filter((l) => planOf(l.id) > 0).map((l) => l.id)), [leafs, planOf]);
  const cumByDay = useMemo(() => cumulativeByDay(dayMap, dayList, plannedIds), [dayMap, dayList, plannedIds]);
  const todayDay = todayDayOf(month, String(daily.today || new Date().toISOString().slice(0, 10)), dayCount);
  const calc = useMemo(() => makeBudgetCalc({ dayMap, dayList, details: daily.plan_details || {}, leafs, todayDay }), [dayMap, dayList, daily.plan_details, leafs, todayDay]);
  const lastExp = cumByDay[dayList[dayList.length - 1]]?.exp || 0;
  return { byId, parents, childrenOf, leafs, dayMap, y, m, dayCount, dayList, totalPlan, cumByDay, todayDay, calc, lastExp };
}
